export default {
    version: "352",
    buildNumber: "79abe4b",
    baseUrl: "https://cf-st.sc-cdn.net/d/mEmSkXfS1qUOSde61X7KE?go=IgsKCTIBBEgBUFxgAQ%3D%3D&uc=92",
};
